const ChecklistThemeListItems = () => {
  return (
    <>
      <option value="0">Default</option>
      <option value="1">Satos5</option>
      <option value="2">Classic</option>
    </>
  );
};

export default ChecklistThemeListItems;